__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/2024-01_PAMELA-ANDERSON/";